import { TrendingUp, Clock, Users } from "lucide-react";
import { Reveal, SectionHeader } from "@/components/Reveal";

const STORIES = [
  {
    icon: TrendingUp,
    title: "Solo Agent in Austin",
    metric: "+340%",
    metricLabel: "lead increase in 3 months",
    text: "One agent replaced sporadic listing photos with a weekly video cadence. Listing inquiries quadrupled within a single quarter.",
  },
  {
    icon: Clock,
    title: "Brokerage in London",
    metric: "6 weeks",
    metricLabel: "saved per quarter",
    text: "A 12-agent brokerage cut video production from 3 weeks per listing to 48 hours — freeing the team to focus on closing.",
  },
  {
    icon: Users,
    title: "Market Report Videos",
    metric: "+180%",
    metricLabel: "open house attendance",
    text: "Monthly market update videos positioned one team as the local authority — and packed their open houses with qualified buyers.",
  },
];

export const SuccessStories = () => (
  <section id="success" className="bg-hero-cream py-24 sm:py-32" data-testid="success-stories-section">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <SectionHeader
        chapter="04 — Proof"
        title="Success Stories"
        sub="Real teams. Real listings. Real numbers."
      />

      <div className="grid gap-8 md:grid-cols-3">
        {STORIES.map((s, i) => (
          <Reveal key={s.title} delay={i * 0.15}>
            <article
              className="group h-full overflow-hidden rounded-md border-2 border-hero-black/10 bg-white shadow-md transition-all duration-300 ease-out hover:-translate-y-2 hover:border-hero-black hover:shadow-xl"
              data-testid={`success-card-${i + 1}`}
            >
              <div className="bg-gradient-to-r from-hero-blue to-hero-gold px-8 py-10">
                <s.icon className="h-8 w-8 text-white drop-shadow" aria-hidden="true" />
                <p className="mt-4 font-display text-5xl font-bold tracking-tight text-white drop-shadow" data-testid={`success-metric-${i + 1}`}>
                  {s.metric}
                </p>
                <p className="mt-1 font-display text-sm font-semibold uppercase tracking-[0.2em] text-white/90">
                  {s.metricLabel}
                </p>
              </div>
              <div className="p-8">
                <h3 className="font-display text-2xl font-bold uppercase tracking-tight text-hero-black">{s.title}</h3>
                <p className="mt-3 text-base leading-relaxed text-hero-black/70">{s.text}</p>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
